module.exports = __webpack_public_path__ + "img/Thanksgiving_s2.56a2d032.png";